var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_drop_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M15.4235 19.2937L10.571 13.4707C10.0038 12.79 10.4878 11.7566 11.3739 11.7566L19.9748 11.7566C20.8609 11.7566 21.3449 12.79 20.7777 13.4707L15.9252 19.2937C15.7947 19.4503 15.554 19.4503 15.4235 19.2937Z",
    fill: "#84C70D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/Arrow_drop_down.901b2ca58a6ed2109510f1bf0788f605.svg";
export { ForwardRef as ReactComponent };